Pixlee.module("SinglePhotoApp.Show", function(Show, App, Backbone, Marionette, $) {

    Show.Layout = App.Views.Layout.extend({
        template: require('./templates/layout.jst.ejs'),
        ui: {
            photo_wrapper: '#photo_wrapper',
            photo_holder: '#photo_holder',
            info_holder: '#info_holder',
            layer_video: '#layer_video',
            play_button: '#play_button',
            mute_button: '#mute_button'
        },
        events: {
            'click #photo_holder': 'openLightbox',
            'keydown #photo_holder': 'openLightbox',
            'click #mute_button': 'muteVideo',
            'click #layer_video': 'controlVideo',
            'keydown #layer_video': 'controlVideo',
            'click #play_button': 'controlVideo'
        },
        onShow: function() {
            this.hasLightbox = true;

            if (typeof gon.show_lightbox !== 'undefined' && _.isFalsy(gon.show_lightbox)) {
                this.ui.photo_holder.addClass('noClick');
                this.hasLightbox = false;
            } else {
                this.ui.mute_button.hide();
            }
            this.updateThumbnailCSS();
        },
        updateThumbnailCSS: function() {
            // Set background CSS properties for image holders based on viewport data
            var viewport = this.view.model.get('viewport');
            var backgroundCss = Pixlee.getViewportBackgroundDimensions(viewport);

            this.ui.photo_holder.css({
                'background-position': backgroundCss.backgroundPosition,
                'background-size': backgroundCss.backgroundSize
            });
        },
        openLightbox: function(ev) {
            // Keycode 13 = Enter Key
            if (ev.type === 'keydown' && ev.keyCode !== 13) {
                return;
            }

            var obj = {
                widget: gon.widget,
            };

            var message = {
                name: 'pixlee:open:lightbox',
                type: 'action',
                source: 'widget',
                destination: 'lightbox',
                data: {
                    modelData: JSON.stringify([this.model.toJSONForLightbox()]),
                    indexToOpen: 0,
                    variables: JSON.stringify(obj),
                    current_album: App.currentAlbum.toJSON(),
                    display_options: App.displayOptions.toJSON(),
                    usingKeyboard: ev.type === 'keydown'
                }
            };
            window.parent.postMessage(JSON.stringify(message), '*');
        },
        muteVideo: function() {
            if (this.ui.layer_video.prop('muted')) {
                this.ui.layer_video.prop('muted', false);
            } else {
                this.ui.layer_video.prop('muted', true);
            }

            this.ui.mute_button.toggleClass('mute');
        },
        controlVideo: function(ev) {

            if (!this.hasLightbox) {
                var video = this.ui.layer_video[0];
                if (video.paused) {
                    video.play();
                } else {
                    video.pause();
                }

                this.ui.play_button.toggle();
                return;
            }

            // Keycode 13 = Enter Key
            if (ev.type === 'keydown' && ev.keyCode !== 13) {
                return;
            }

            var obj = {
                widget: gon.widget,
            };

            var message = {
                name: 'pixlee:open:lightbox',
                type: 'action',
                source: 'widget',
                destination: 'lightbox',
                data: {
                    modelData: JSON.stringify([this.model.toJSONForLightbox()]),
                    indexToOpen: 0,
                    variables: JSON.stringify(obj),
                    current_album: App.currentAlbum.toJSON(),
                    display_options: App.displayOptions.toJSON(),
                    usingKeyboard: ev.type === 'keydown'
                }
            };
            window.parent.postMessage(JSON.stringify(message), '*');
        },
        templateHelpers: function() {
            var _this = this;
            return {
                getSocialLink: function() {
                    var platformLink = _this.model.get('platform_link') || '';
                    if (_this.model.get('source') === 'instagram' && platformLink.slice(-1) !== '/') {
                        return platformLink + '/';
                    } else {
                        return platformLink;
                    }
                },

                getPhotoLink: function() {
                    if (!_.isFalsy(_this.model.get('pixlee_cdn_photos')) && !_.isFalsy(_this.model.get('pixlee_cdn_photos').original_url)) {
                        return _this.model.get('pixlee_cdn_photos').original_url;
                    }
                    return _this.model.get('source_url');
                },
                getUsername: function() {
                    if (_this.model.isAnonymousInstagram()) {
                        return '<i class="anonymous_instagram">' + I18n.t('lightbox.avatar.anonymous_user');
                    } else {
                        var userHandle = _this.model.get('source') === 'desktop' ? '' : '@';
                        // EN-6484: user_name is rendered raw via [%= getUsername() %], so
                        // HTML-encode it here to prevent stored XSS.
                        return userHandle + App.request('escape:html', _this.model.get('user_name'));
                    }
                },
                getSource: function() {
                    return _this.model.get('source');
                },
                isVideo: function() {
                    return _this.model.get('content_type') === 'video';
                },
                isYoutube: function() {
                    return _this.model.get('source') === 'youtube';
                },
                getBigUrl: function() {
                    return _this.model.get('big_url');
                },
                shouldShowProductBadges: function() {
                    return this.hasProducts() && !!gon.display_options.productBadgeLayout;
                },
                hasProducts: function() {
                    return this.products && this.products.length > 0;
                },
                getProductBadgeClasses: function() {
                    var layout = gon.display_options.productBadgeLayout;
                    var classes = {
                        black_bg_white_solid: 'circle_icon white filled_bag',
                        white_solid: 'white filled_bag black_shadow',
                        black_solid: 'black filled_bag white_shadow',
                        black_bg_white_outline: 'circle_icon white regular_bag',
                        black_bg_white_light: 'circle_icon white light_bag',
                        black_outline: 'black regular_bag',
                        black_light: 'black light_bag'
                    };
                    return classes[layout] || '';
                }
            };
        }
    });
    Show.Layout.include(['AccessibilityHelpers', 'socialShareHelpers']);
});
